import type { AppModule } from '@support/core';

import * as routes from './routes.js';

export const PublishersModule: AppModule = {
  routes,
};
